"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const HeroSkeletonWrapper = styled_components_1.default.div(({ height }) => ({
    height: `${height}px`,
}));
const HeroSkeleton = ({ className, height }) => {
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const defaultHeight = mobile ? 185 : 567;
    return (react_1.default.createElement(HeroSkeletonWrapper, { height: height !== null && height !== void 0 ? height : defaultHeight, className: className },
        react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { uid: "hero-skeleton", width: 100, height: 100, style: {
                width: '100%',
                height: '100%',
                display: 'block',
            } },
            react_1.default.createElement("rect", { width: "100", height: "100" }))));
};
exports.default = HeroSkeleton;
//# sourceMappingURL=Hero.skeleton.js.map